export const getUrlCheckIpService = (ip) =>
	`https://whatismyipaddress.com/ip/${ip}`;
